import { useMemo } from 'react';
import { sumBy } from 'lodash';

import { ReviewHourBlockFragment } from '@common/graphql/schema';

export const useHasHoliday = (
  blocks: ReviewHourBlockFragment[] | undefined | null
) => {
  return useMemo(
    () =>
      !!sumBy(blocks || [], (block) => block.classifiedTimes.holidaySeconds),
    [blocks]
  );
};
